import React, { useEffect } from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from './Series.module.css'
import AOS from 'aos';
import 'aos/dist/aos.css'
import { useDispatch, useSelector } from 'react-redux';
import { seriesList } from '../../features/series/seriesSlice';
import { Link } from 'react-router-dom';
import demoIMage from '../../assets/images/download.jpeg'
import Skeleton from '../Skeleton/Skeleton';

const Series = () => {

  const dispatch = useDispatch();
  const data = useSelector((state) => state.series.data);
  const pending = useSelector((state) => state.series.pending);
  const error = useSelector((state) => state.series.error);
  const finalData = data.data;
  // console.log(finalData)
    var settings = {
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 500,
        swipeToSlide: true,
        responsive: [

          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              
            }
          },
    
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
    
        ]
       
      };

      
     

      useEffect(() =>{
        // AOS.init({duration : 2000})

        
          dispatch(seriesList());
       
      },[dispatch])

      if (pending) {
        return  (<div className={styles.loader}>
        <Skeleton type= "series" />
      </div>);
      }
      if (error) {
        return <div>Error: {error}</div>;
      }
      return (
        <div className={styles.parentContainer} name='series' >
        <div className={styles.fixturesHeading}>
          <h3>TRENDING SERIES</h3>
        </div>
        <div className={styles.mainContainer}>
          
          <Slider {...settings} className={styles.mainSliderContainer}>
            {finalData &&
              finalData.map((item, index) => (
                <Link to={`/series/${item.series_id}`}>
                <div className={styles.slide} key={index}>

                 <div className={styles.seriesData}>
                    <div className={styles.firstContainer}>
                        <div className={styles.seriesName}>
                          <h3>{item.series}</h3>
                          
                          
                        </div>
                        <div className={styles.dateAndMatches}>
                          <p>{item.series_date}</p>
                          <p>{item.total_matches} Matches</p>
                        </div>
                      
                    </div>
                    <div className={styles.secondContainer}>
                      <img src={`https://images.weserv.nl/?url=${item.image}` } alt='' />
                     
                    </div>
                    </div>
                 
                  
                </div>
                 </Link>
              ))}
          </Slider>
          <div className={styles.allFixturesButton}>
            {/* <Link to='/siteMaintenance'> */}
            {/* <button>VIEW ALL</button> */}
            {/* </Link> */}
            
          </div>
        </div>
      </div>
   
  )
}

export default Series
